import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './PartnersSlider.css';
import Heading from '../../../utls/Heading';
const PartnersSlider = () => {
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 2000,
        cssEase: "linear",
        arrows: false, // Disables the navigation arrows
        responsive: [
          {
            breakpoint: 430,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 380,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 325,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }
        ],
      };

  return (
    <div className="partners-slider mt-5 pt-lg-5 mb-5 pb-lg-5" >
        <Heading className='customheadings text-center mt-xxl-4 mb-4'>OUR PARTNERS</Heading>
        <Slider {...settings}>
                <div>
                  <LazyLoadImage
            effect="blur"
 src={"https://blueberrydatastorage.blob.core.windows.net/bbg/All%20BBG%20Website%20Images/Suppliers%20New%20Logo/Artboard%201%20copy%202.svg"} alt="Logo 1" className="partners5-slider-image" loading="lazy"  />
                </div>
                <div>
                  <LazyLoadImage
            effect="blur"
 src={"https://blueberrydatastorage.blob.core.windows.net/bbg/All%20BBG%20Website%20Images/Suppliers%20New%20Logo/Artboard%201%20copy%203.svg"} alt="Logo 2" className="partners5-slider-image" loading="lazy" />
                </div>
                <div>
                  <LazyLoadImage
            effect="blur"
 src={"https://blueberrydatastorage.blob.core.windows.net/bbg/All%20BBG%20Website%20Images/Suppliers%20New%20Logo/Artboard%201%20copy%204.svg "} alt="Logo 2" className="partners5-slider-image" loading="lazy" />
                </div>
                <div>
                  <LazyLoadImage
            effect="blur"
 src={"https://blueberrydatastorage.blob.core.windows.net/bbg/All%20BBG%20Website%20Images/Suppliers%20New%20Logo/Artboard%201%20copy%205.svg "} alt="Logo 2" className="partners5-slider-image" loading="lazy" />
                </div>
                <div>
                  <LazyLoadImage
            effect="blur"
 src={" https://blueberrydatastorage.blob.core.windows.net/bbg/All%20BBG%20Website%20Images/Suppliers%20New%20Logo/Artboard%201%20copy%206.svg"} alt="Logo 2" className="partners5-slider-image" loading="lazy" />
                </div>
                <div>
                  <LazyLoadImage
            effect="blur"
 src={"https://blueberrydatastorage.blob.core.windows.net/bbg/All%20BBG%20Website%20Images/Suppliers%20New%20Logo/Artboard%201%20copy%207.svg "} alt="Logo 2" className="partners5-slider-image" loading="lazy" />
                </div>
                <div>
                  <LazyLoadImage
            effect="blur"
 src={"https://blueberrydatastorage.blob.core.windows.net/bbg/All%20BBG%20Website%20Images/Suppliers%20New%20Logo/Artboard%201%20copy%208.svg "} alt="Logo 2" className="partners5-slider-image" loading="lazy" />
                </div>
                <div>
                  <LazyLoadImage
            effect="blur"
 src={" https://blueberrydatastorage.blob.core.windows.net/bbg/All%20BBG%20Website%20Images/Suppliers%20New%20Logo/Artboard%201%20copy.svg"} alt="Logo 2" className="partners5-slider-image" loading="lazy" />
                </div>
                <div>
                  <LazyLoadImage
            effect="blur"
 src={"https://blueberrydatastorage.blob.core.windows.net/bbg/All%20BBG%20Website%20Images/Suppliers%20New%20Logo/Artboard%201.svg"} alt="Logo 2" className="partners5-slider-image" loading="lazy" />
                </div>
              </Slider>
    </div>
  );
};

export default PartnersSlider;
